import React, { FC } from 'react';

import { IComboSlot, IItem, IItemOption, IPickerItem, ISanityItemOption } from '@rbi-ctg/menu';
import { ComboSlot } from 'components/menu-order-wizard/combo-slot';
import Modifiers from 'components/menu-order-wizard/modifiers';
import QuickConfigs from 'components/menu-order-wizard/quick-configs';
import SimpleWizardItem from 'components/menu-order-wizard/simple-wizard-item';
import { MenuObjectTypes } from 'enums/menu';
import { getItemCalories } from 'utils/menu';

import { IMenuItemCustomizationProps } from './types';

const MenuItemCustomization: FC<IMenuItemCustomizationProps> = ({
  menuItem,
  comboSlotSelections,
  excludesForPickerAspects = [],
  handleComboSelection,
  handleComboSlotSelectionQuantityUpdate,
  modifierSelections = [],
  handleModifierSelection,
  handleModifierQuantityUpdate,
  pricingFunction,
  quickConfigs = [],
  comboSlotsToShow,
  showModifiers = true,
}) => {
  let item: IItem | null = null;
  let showMainItem = false;
  let mainItemCalories = 0;
  let modifiersUnderMainItem = false;
  let modifiers: (ISanityItemOption | IItemOption)[] = [];
  let comboSlots: IComboSlot[] = [];
  let radioGroupParentId = '';

  if (menuItem) {
    if (menuItem._type === MenuObjectTypes.ITEM) {
      item = menuItem;
      modifiers = menuItem.options || [];
      radioGroupParentId = menuItem._id;
    } else {
      item = menuItem.mainItem;
      showMainItem = !menuItem.hideMainItemDescription;
      mainItemCalories = item ? getItemCalories(item) : 0;
      modifiersUnderMainItem = !menuItem.forceModifiersToBottom;
      modifiers = item ? item.options : [];
      comboSlots = menuItem.options.filter(
        slot =>
          slot.uiPattern !== 'hidden' &&
          slot.options.some(opt => pricingFunction(opt.option) !== undefined) &&
          (comboSlotsToShow ? comboSlotsToShow.includes(slot._id) : true)
      );
      radioGroupParentId = item ? item._id : '';
    }
  }

  const modifiersElem = showModifiers && (
    <Modifiers
      item={item}
      quickConfigs={quickConfigs}
      modifiers={modifiers}
      excludesForPickerAspects={excludesForPickerAspects}
      radioGroupParentId={radioGroupParentId}
      modifierSelections={modifierSelections.filter(({ comboSlotId }) => !comboSlotId)}
      handleModifierSelection={handleModifierSelection}
      handleModifierQuantityUpdate={handleModifierQuantityUpdate}
    />
  );

  return (
    <>
      {showMainItem && item && (
        <SimpleWizardItem title={item.name?.locale} calories={mainItemCalories} />
      )}

      <QuickConfigs
        handleModifierSelection={handleModifierSelection}
        modifierSelections={modifierSelections}
        pickerSelection={(menuItem as unknown) as IPickerItem}
        quickConfigs={quickConfigs}
      />

      {modifiersUnderMainItem && modifiersElem}

      {menuItem?._type === MenuObjectTypes.COMBO &&
        comboSlots.map((comboSlot, i) => (
          <ComboSlot
            key={`${comboSlot._id}:${i}`}
            combo={menuItem}
            comboSlot={comboSlot}
            comboSlotSelections={comboSlotSelections}
            handleComboSelection={handleComboSelection}
            handleComboSlotSelectionQuantityUpdate={handleComboSlotSelectionQuantityUpdate}
            handleModifierSelection={handleModifierSelection}
            handleModifierQuantityUpdate={handleModifierQuantityUpdate}
            modifierSelections={modifierSelections}
          />
        ))}

      {!modifiersUnderMainItem && modifiersElem}
    </>
  );
};

export default MenuItemCustomization;
